var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70211 18C2.48265 18 2.33635 17.9276 2.19005 17.7828C1.9706 17.5656 1.9706 17.3484 2.04375 17.0588L3.14101 13.4389C3.28731 12.8597 3.65307 12.2081 4.16512 11.7738L13.0164 2.86878C13.6016 2.28959 14.3331 2 15.1378 2C15.8693 2 16.6008 2.28959 17.186 2.79638C18.2832 3.88235 18.2832 5.76471 17.1128 6.92308L9.65144 14.3801C9.35883 14.6697 8.91993 14.6697 8.62733 14.3801C8.33472 14.0905 8.33472 13.6561 8.62733 13.3665L16.0887 5.9819C16.6739 5.40271 16.7471 4.38914 16.1619 3.80995C15.8693 3.52036 15.5035 3.37557 15.1378 3.37557C14.6988 3.37557 14.3331 3.52036 13.9673 3.88235L5.26239 12.5701L7.82267 15.1041C7.96897 15.2489 8.04212 15.4661 8.04212 15.6833C8.04212 15.9005 7.89582 16.1176 7.74952 16.19L7.60321 16.2624C7.23746 16.4796 6.87171 16.6968 6.4328 16.8416L2.84841 17.9276C2.77526 18 2.77526 18 2.70211 18ZM4.53088 13.7285C4.53088 13.8009 4.53088 13.8009 4.45773 13.8733L3.72622 16.2624L6.06705 15.5385C6.1402 15.5385 6.1402 15.5385 6.21335 15.4661L4.53088 13.7285Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDisabledIcon);
export default __webpack_public_path__ + "static/media/edit-disabled-icon.3eb99188483a822c8c7d48347f4f7e5e.svg";
export { ForwardRef as ReactComponent };